import React, { useState, useEffect } from 'react';
import { Modal, Button, Container, Row, Col } from 'react-bootstrap';
import ProductServices from '../../../services/ProductServices';
import CategoryServices from '../../../services/CategoryServices';
import SubCategoryServices from '../../../services/SubCategoryServices';
import Swal from 'sweetalert2';

const MasterListEdit = ({ show, handleClose, test, item }) => {
  const [rate, setRate] = useState('');
  const [description, setDescription] = useState('');
  const [image, setImage] = useState(null);
  const [previewImage, setPreviewImage] = useState('');
  const [units, setUnits] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState('');
  const [remark, setRemark] = useState('');
  const [subCategories, setSubCategories] = useState([]); // ✅ Store fetched subcategories
  const [selectedSubCategory, setSelectedSubCategory] = useState(''); // ✅ Store selected subcategory
  const [categories, setCategories] = useState([]);   // ✅ store categories
  const [selectedCategory, setSelectedCategory] = useState(''); // ✅ selected category

  // Fetch category units and subcategories when modal opens
  useEffect(() => {
    if (show) {
      CategoryServices.getCategory()
        .then((response) => setCategories(response?.data?.data || []))
        .catch((error) => console.error("Error fetching categories:", error));

      CategoryServices.getUnit()
        .then((response) => setUnits(response?.data?.data || []))
        .catch((error) => console.error("Error fetching units:", error));

      SubCategoryServices.getSubCategory() // ✅ Your API to fetch subcategories
        .then((response) => setSubCategories(response?.data?.data || []))
        .catch((error) => console.error("Error fetching subcategories:", error));
    }
  }, [show]);

  // Set default values when item changes
  useEffect(() => {
    if (item) {
      setDescription(item.description || '');
      setPreviewImage(item.image ? `https://indigoinfra.in/img/product/${item.image}` : '');
      setSelectedUnit(item.unit?._id || '');
      setSelectedSubCategory(item.subCategory?._id || ''); // ✅ Preselect subcategory
      setRemark(item.remark || '');
      setRate(item.rate || 0);   // ✅ pre-fill rate
      setSelectedCategory(item.category?._id || '');   // ✅ pre-fill category
    }
  }, [item]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setPreviewImage(reader.result);
      reader.readAsDataURL(file);
      setImage(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('description', description);
    formData.append('unit', selectedUnit);
    formData.append('remark', remark);
    formData.append('category', selectedCategory);
    formData.append('rate', rate);

    // ✅ Only append subCategory if user selected one
    if (selectedSubCategory) {
      formData.append('subCategory', selectedSubCategory);
    }

    // ✅ Only append image if changed
    if (image) {
      formData.append('photo', image);
    }

    try {
      await ProductServices.updateProduct(item._id, formData);
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Item updated successfully!',
        timer: 2000,
        showConfirmButton: false,
      });
      setTimeout(() => {
        test((prev) => prev + 1);
        handleClose();
      }, 2000);
    } catch (error) {
      console.error('Error updating the item', error);
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'There was a problem updating the item. Please try again later.',
      });
    }
  };


  return (
    <Modal className="fade" show={show} onHide={handleClose}>
      <form onSubmit={handleSubmit}>
        <Modal.Header>
          <Modal.Title><i className="fas fa-edit"></i> Edit Master Item</Modal.Title>
          <Button variant="" className="btn-close" onClick={handleClose}></Button>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row>
              <Col md="6">
                <label>Part No.</label>
                <input type="text" className="form-control form-control-sm" value={item?.partNo || 'N/A'} readOnly />
              </Col>
              <Col md="6">
                <label>Category</label>
                <select
                  className="form-control form-control-sm"
                  value={selectedCategory}
                  onChange={(e) => setSelectedCategory(e.target.value)}
                >
                  <option value="">-- Select Category --</option>
                  {categories.map((cat) => (
                    <option key={cat._id} value={cat._id}>
                      {cat.name}
                    </option>
                  ))}
                </select>
              </Col>


              <Col md="6">
                <label>Subcategory</label>
                <select
                  className="form-control form-control-sm"
                  value={selectedSubCategory}
                  onChange={(e) => setSelectedSubCategory(e.target.value)}
                >
                  <option value="">-- Select Subcategory --</option>
                  {subCategories.map((sub) => (
                    <option key={sub._id} value={sub._id}>
                      {sub.name}
                    </option>
                  ))}
                </select>
              </Col>

              <Col md="6">
                <label>Unit</label>
                <select
                  className="form-control form-control-sm"
                  value={selectedUnit}
                  onChange={(e) => setSelectedUnit(e.target.value)}
                >
                  {units.map((unit) => (
                    <option key={unit._id} value={unit._id}>
                      {unit.name}
                    </option>
                  ))}
                </select>
              </Col>

              <Col md="6">
                <label>Rate</label>
                <input
                  type="number"
                  className="form-control form-control-sm"
                  value={rate}
                  onChange={(e) => setRate(e.target.value)}
                  placeholder="Enter Rate"
                />
              </Col>


              <Col md="6">
                <label>Remark</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                  placeholder="Enter your remark here"
                />
              </Col>

              <Col md="12">
                <label>Description</label>
                <textarea
                  rows="1"
                  className="form-control form-control-sm"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </Col>

              <Col md="12" className="mt-3">
                <label>Current Image</label>
                <div className="file-preview text-center">
                  {previewImage ? <img src={previewImage} alt="Preview" style={{ maxWidth: '180px' }} /> : <p>No image available</p>}
                </div>
                <label className="mt-2">Change Image</label>
                <input type="file" className="form-control form-control-sm" accept="image/*" onChange={handleImageChange} />
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger light" onClick={handleClose}>Close</Button>
          <Button variant="primary" type="submit">Save Changes</Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};


export default MasterListEdit;
